import React from "react";
import { Box, VStack, Text, Image } from "@chakra-ui/react";
import b5 from "../assets/images/benk/b5.jpg"; // Importer bildet direkte

const HeroSection = ({ onScroll }) => {
    return (
        <Box display="flex" flexDirection={{ base: "column", md: "row" }} alignItems="center" justifyContent="center" p={8} minH="80vh" pt="70px">
            <VStack align="flex-start" spacing={6} maxW="500px">
                <Text fontSize="4xl" fontWeight="bold" color="gray.800">
                    Make a Cozy Home
                </Text>
                {/*<Button onClick={onScroll} colorScheme="teal" variant="solid" size="lg">*/}
                {/*    View Products*/}
                {/*</Button>*/}
            </VStack>
            <Image
                src={b5} // Bruk importert bilde
                alt="Furniture"
                borderRadius="md"
                maxW="700px"
                height="auto"
            />
        </Box>
    );
};

export default HeroSection;
